module.exports = require("mdi-react/CloseIcon");